import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export default function PublicRoute({ children }) {
  const { user } = useSelector((state) => state.user);
  const token = localStorage.getItem("token");

  if (!token) return children;

  if (user?.isAdmin) return <Navigate to="/admin-dashboard" replace />;
  return <Navigate to="/" replace />;
}
